export const FETCH_ORDER_LIST_BY_BUTTON_REQUEST =
  'FETCH_ORDER_LIST_BY_BUTTON_REQUEST'
export const FETCH_ORDER_LIST_BY_BUTTON_SUCCESS =
  'FETCH_ORDER_LIST_BY_BUTTON_SUCCESS'
export const FETCH_ORDER_LIST_BY_BUTTON_FAILURE =
  'FETCH_ORDER_LIST_BY_BUTTON_FAILURE'

export const HOMEPAGE_REGIONS_REQUEST = 'HOMEPAGE_REGIONS_REQUEST'
export const HOMEPAGE_REGIONS_SUCCESS = 'HOMEPAGE_REGIONS_SUCCESS'
export const HOMEPAGE_REGIONS_FAILURE = 'HOMEPAGE_REGIONS_FAILURE'

export const RESTAURANT_DETAILS_REQUEST = 'RESTAURANT_DETAILS_REQUEST'
export const RESTAURANT_DETAILS_SUCCESS = 'RESTAURANT_DETAILS_SUCCESS'
export const RESTAURANT_DETAILS_FAILURE = 'RESTAURANT_DETAILS_FAILURE'

export const FOOTER_DETAILS_PAGE_REQUEST = 'FOOTER_DETAILS_PAGE_REQUEST'
export const FOOTER_DETAILS_PAGE_SUCCESS = 'FOOTER_DETAILS_PAGE_SUCCESS'
export const FOOTER_DETAILS_PAGE_FAILURE = 'FOOTER_DETAILS_PAGE_FAILURE'

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE'

export const DELETE_ACCOUNT_REQUEST = 'DELETE_ACCOUNT_REQUEST'
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS'
export const DELETE_ACCOUNT_ERROR = 'DELETE_ACCOUNT_ERROR'

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'

export const FOOTER_REQUEST = 'FOOTER_REQUEST'
export const FOOTER_SUCCESS = 'FOOTER_SUCCESS'
export const FOOTER_FAILURE = 'FOOTER_FAILURE'

export const CART_CREATE_BUSINESS_INFO = 'CART_CREATE_BUSINESS_INFO'
export const CART_WIPE_ALL_BUSINESS_INFO = 'CART_WIPE_ALL_BUSINESS_INFO'
export const CART_ADD_ITEM = 'CART_ADD_ITEM'
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM'
export const CART_INCREASE_QUANTITY = 'CART_INCREASE_QUANTITY'
export const CART_DECREASE_QUANTITY = 'CART_DECREASE_QUANTITY'

export const RESTAURANT_LIST_ITEMS = 'RESTAURANT_LIST_ITEMS'

export const GET_LOCATIONS_REQUEST = 'GET_LOCATIONS_REQUEST'
export const GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS'
export const GET_LOCATIONS_FAILURE = 'GET_LOCATIONS_FAILURE'

export const SET_USER_ADDRESS_REQUEST = 'SET_USER_ADDRESS_REQUEST'
export const SET_USER_ADDRESS_SUCCESS = 'SET_USER_ADDRESS_SUCCESS'
export const SET_USER_ADDRESS_FAILURE = 'SET_USER_ADDRESS_FAILURE'

export const SET_DELIVER_DETAILS = 'SET_DELIVER_DETAILS'

export const COUPON_DISCOUNT_REQUEST = 'COUPON_DISCOUNT_REQUEST'
export const COUPON_DISCOUNT_SUCCESS = 'COUPON_DISCOUNT_SUCCESS'
export const COUPON_DISCOUNT_FAILURE = 'COUPON_DISCOUNT_FAILURE'

export const CART_ORDER_REQUEST = 'CART_ORDER_REQUEST'
export const CART_ORDER_SUCCESS = 'CART_ORDER_SUCCESS'
export const CART_ORDER_FAILURE = 'CART_ORDER_FAILURE'

export const SET_CURRENCY = 'SET_CURRENCY'

export const RESET_CART = 'RESET_CART'
export const RESET_TO_INITIAL_STATE = 'RESET_TO_INITIAL_STATE'

export const SEARCHED_PRODUCTS = 'SEARCHED_PRODUCTS'
export const RESET_SEARCHED_PRODUCTS = 'RESET_SEARCHED_PRODUCTS'
export const SEARCHED_BUSINESS = 'SEARCHED_BUSINESS'

export const ALL_ORDER_DETAILS_REQUEST = 'ALL_ORDER_DETAILS_REQUEST'
export const ALL_ORDER_DETAILS_SUCCESS = 'ALL_ORDER_DETAILS_SUCCESS'
export const ALL_ORDER_DETAILS_FAILURE = 'ALL_ORDER_DETAILS_FAILURE'

export const SINGLE_ORDER_DETAILS_REQUEST = 'SINGLE_ORDER_DETAILS_REQUEST'
export const SINGLE_ORDER_DETAILS_SUCCESS = 'SINGLE_ORDER_DETAILS_SUCCESS'
export const SINGLE_ORDER_DETAILS_FAILURE = 'SINGLE_ORDER_DETAILS_FAILURE'

export const SET_POST_CODE_VALIDATION = 'SET_POST_CODE_VALIDATION'

export const CART_ORDER_TOGGLE_LOADING = 'CART_ORDER_TOGGLE_LOADING'
export const SET_SINGLE_DELIVERY_KEY = 'SET_SINGLE_DELIVERY_KEY'

export const SET_STRIPE_ORDER_STATUS = 'SET_STRIPE_ORDER_STATUS'
export const RESET_STRIPE_ORDER_STATUS = 'RESET_STRIPE_ORDER_STATUS'

export const SET_ORDER_LOADING = 'SET_ORDER_LOADING'
export const SET_CREDIT_CARD_ISO_CODE = 'SET_CREDIT_CARD_ISO_CODE'

export const CALCULATE_FEE_REQUEST = 'CALCULATE_FEE_REQUEST'
export const CALCULATE_FEE_SUCCESS = 'CALCULATE_FEE_SUCCESS'
export const CALCULATE_FEE_FAILURE = 'CALCULATE_FEE_FAILURE'

export const PROFILE_INFO_REQUEST = 'PROFILE_INFO_REQUEST'
export const PROFILE_INFO_SUCCESS = 'PROFILE_INFO_SUCCESS'
export const PROFILE_INFO_FAILURE = 'PROFILE_INFO_FAILURE'

export const SET_SERVICE_TIME_DETAILS = 'SET_SERVICE_TIME_DETAILS'
export const SET_SERVICE_DELIVERY_TYPE = 'SET_DELIVERY_TYPE'
export const SET_SERVICE_ADDRESS_DETAILS = 'SET_SERVICE_ADDRESS_DETAILS'

export const CART_REMOVE_ALL_ITEMS = 'CART_REMOVE_ALL_ITEMS'

export const IFRAME_MY_ORDERS_CLICK = 'IFRAME_MY_ORDERS_CLICK'

export const UPDATE_ALL_ORDERS_FROM_SIGNALR = 'UPDATE_ALL_ORDERS_FROM_SIGNALR'

export const SERVICE_LIST_SUCCESS = 'SERVICE_LIST_SUCCESS'
export const SERVICE_LIST_SET_SELECTED_REGION =
  'SERVICE_LIST_SET_SELECTED_REGION'
